import { render, staticRenderFns } from "./ResetConfirmEmail.vue?vue&type=template&id=c37dc1c4&lang=pug&"
import script from "./ResetConfirmEmail.vue?vue&type=script&lang=js&"
export * from "./ResetConfirmEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports